import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  useGetSupplierGroupsQuery,
  useGetSupplierGroupCountQuery
} from "../../../../store/api/supplier";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import PopBox from "../../../../Components/Popup/Popup";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ExportCSV from '../../../../Core/Export/ExportCSV'
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import { useDeleteDocMutation } from '../../../../store/api/globalapi'
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";
const MainContent = () => {
  const navigate = useNavigate();
  const { screenHeight, screenScaling,pageSize } = useScreenHeight();
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [isPopBoxOpen, setIsPopBoxOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [showExportPopup, setShowExportPopup] = useState(false);
  const [showColumnConfig, setShowColumnConfig] = useState(false);

    const [deleteDoc] = useDeleteDocMutation();
		const [delPopupVisible, setDelPopupVisible] = useState(false);
		const [delSelectedId, setDelSelectedId] = useState(null);
		const [delmessage, setDelmessage] = useState();
		const [alreadySubmitData, setAlreadySubmitData] = useState(false);
		const [delDone, setDelDone] = useState(false);

  const siNoFilter = filters.siNo?.trim();
  const isSiNoActive = siNoFilter !== undefined && siNoFilter !== "";

  const targetPage = isSiNoActive
    ? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
    : currentPage;

  // Create filters array for API
  const buildFilterArray = (filtersObj) => {
    return Object.entries(filtersObj)
      .filter(([key, value]) => key !== "siNo" && value?.trim() !== "")
      .map(([key, value]) => {
        if (key === "creation") {
          return ["Supplier Group", key, "like", `${value}%`];
        }
        if (key === "name" || key === "parent_supplier_group") {
          return ["Supplier Group", key, "like", `%${value}%`];
        }
        return ["Supplier Group", key, "=", value];
      });
  };

  // Data fetch
  const {
    data: supplierGroupsData,
    isLoading: supplierGroupsLoading,
    refetch:refetchSuppGroupData
  } = useGetSupplierGroupsQuery({
    start: (targetPage - 1) * pageSize,
    limit: pageSize,
    filters: buildFilterArray(filters),
  });

  const { data: totalCount , refetch: refetchSuppGroupCount } = useGetSupplierGroupCountQuery();
  const totalRecords = totalCount?.message;

  // Apply SI.No filtering
  useEffect(() => {
    if (supplierGroupsData) {
      const rawData = supplierGroupsData.data || [];
      const numberedData = rawData.map((item, idx) => ({
        ...item,
        siNo: idx + 1 + pageSize * (targetPage - 1)
      }));

      const finalData = isSiNoActive
        ? numberedData.filter(item => item.siNo === parseInt(siNoFilter, 10))
        : numberedData;

      setTableData(finalData);

      // ensure pagination aligns
      if (isSiNoActive && currentPage !== targetPage) {
        setCurrentPage(targetPage);
      }
    }
  }, [supplierGroupsData, isSiNoActive, siNoFilter, targetPage, currentPage, pageSize]);

  useEffect(() => {
		if (pageSize > 0) refetchSuppGroupData();
	}, [
		filters,
		currentPage,
		refetchSuppGroupData,
		pageSize,
		screenHeight,
		screenScaling,
	]);

  const filtersConfig = [
    { name: "siNo", label: "S. No.", width: "9%", type: 'number' },
    { name: "name", label: "ID", width: "27%", type: 'text' },
    { name: "parent_supplier_group", label: "Parent Supplier Group", width: "27%", type: 'text' },
    { name: "creation", label: "Date", type: "date", width: "24%" }
  ];

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };

  const handleView = (id) => {
    navigate(`/master/suppliergroup/view-supplier`, { state: { supplier: id } });
  };

  const handleEdit = (id) => {
    navigate(`/master/suppliergroup/edit-supplier`, { state: { supplier: id } });
  };

const handleDelete = (id) => {
	setDelSelectedId(id);
	setDelPopupVisible(true);
	setAlreadySubmitData(false);
	setDelmessage("Are you sure you want to Delete this Supplier Group?");
};

const delHandleCancel = () => {
	setDelPopupVisible(false);
	setDelSelectedId(null);
};

const delHandleConfirm = async () => {
	try {
		await deleteDoc({
			doctype: "Supplier Group",
			name: delSelectedId,
		}).unwrap();
		setDelmessage(`Supplier Group ${delSelectedId} deleted successfully!`);
		setDelDone(true);
		setTimeout(() => {
			setDelPopupVisible(false);
			setDelSelectedId(null);
			setDelDone(false);
      refetchSuppGroupCount(); 
      refetchSuppGroupData();
		}, 1000);
	} catch (err) {
		console.error("Deletion Failed:", err);

		let errorMessage = "Failed to delete the Supplier Group!";

		//If the server is sending the error message , we will extract it.
		if (err?.data?._server_messages) {
			try {
				const messageArr = JSON.parse(err.data._server_messages);
				if (messageArr && messageArr.length > 0) {
					//parse inner json object
					const messageObj = JSON.parse(messageArr[0]);
					if (messageObj?.message) {
						//extract the exact message we want
						const fullMessage = messageObj.message;
						errorMessage = fullMessage.split("You must")[0].trim();
						//remove html in the message
						errorMessage = errorMessage.replace(/<[^>]+>/g, "");
					}
				}
			} catch (parseError) {
				console.error("Error parsing server messages:", parseError);
			}
		}
		setDelPopupVisible(true);
		setDelmessage(errorMessage);
		setAlreadySubmitData(true);
	} finally {
		// setTimeout(() => {
		//     setDelPopupVisible(false);
		//     setDelSelectedId(null);
		// }, 2000);
	}
};

  const [columnsConfig, setColumnsConfig] = useState(() => [
    {
      header: "S. No.",
      accessor: "siNo",
      name: "S. No.",
      sortable: false,
      visible: true,
      width: "8%"
    },
    {
      header: "ID",
      accessor: "name",
      name: "ID",
      visible: true,
      width: "33%"
    },
    {
      header: "Parent Supplier Group",
      name: "Parent Supplier Group",
      accessor: "parent_supplier_group",
      sortable: true,
      visible: true,
      width: "33%"
    },
    {
      header: "Date",
      name: "Date",
      accessor: "creation",
      sortable: true,
      visible: true,
      cellRenderer: (row) => row.creation?.split(" ")[0],
      width: "24%"
    },
    {
      header: "Action",
      name: "Action",
      accessor: 'action',
      width: "0%",
      visible: true,
      cellRenderer: (row) => (
        <ActionButtonDropdown
          id={row.name}
          onView={() => handleView(row.name)}
          onEdit={() => handleEdit(row.name)}
          onDelete={() => handleDelete(row.name)}
        />
      )
    }
  ]);

  // Handle column configuration changes
  const handleSaveColumns = (selectedKeys, allFields) => {
    const updatedColumns = columnsConfig.map(column => {
      return {
        ...column,
        visible: selectedKeys.includes(column.accessor)
      };
    });
    setColumnsConfig(updatedColumns);
  };

  const visibleColumns = useMemo(() =>
    columnsConfig.filter(col => col.visible === true),
    [columnsConfig]
  );

  const defaultSelectedColumns = useMemo(() =>
    columnsConfig
      .filter(col => col.visible === true)
      .map(col => ({
        fieldname: col.accessor,
        label: col.name
      }))
      .filter(col => col.fieldname),
    [columnsConfig]
  );
  const activeFilterCount = useMemo(() => {
    return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
  }, [filters]);

  const actionButtons = [
    {
      className: "createbtn border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "IoFilterSharp",
      iconSize: 12,
      children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
      onClick: () => {
        setShowFilters(prev => !prev);
        setShowColumnConfig(false);
      }
    },
    {
      className: "createbtn border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "MdOutlineRemoveRedEye",
      iconSize: 12,
      children: "Show more",
      onClick: () => {
        setShowColumnConfig(prev => !prev);
        setShowFilters(false);
      }
    },
    {
      className: "createbtn border-0 d-flex",
      style: { gap: "2px", height: "28px" },
      iconName: "RiFileExcel2Fill",
      iconSize: 12,
      children: "Export Excel",
      onClick: () => setShowExportPopup(true),

    },
    {
      className: "custom-btn-00989 d-flex",
      to: "/master/suppliergroup/create-supplier",
      iconName: "FiPlus",
      style: { gap: "2px", height: "28px" },
      children: "Add Supplier Group"
    }
  ];
  const [showFilters, setShowFilters] = useState(false)
  const accessors = columnsConfig
		.filter(
			(column) => column.accessor !== "siNo" && column.accessor !== "action"
		)
		.map((column) => column.accessor);
  return (
		<div
			className="container-fluid d-flex flex-column"
			style={{ flexGrow: "1" }}
		>
			<Tabs />
			<ListLayout
				breadcrumbItems={[
					{ label: "Supplier Group" },
					{ label: "Supplier Group List", style: { color: "#270B79" } },
				]}
				actionButtons={actionButtons}
			>
				{showFilters && (
					<ListFilters
						filtersConfig={filtersConfig}
						onFilterChange={handleFilterChange}
						currentFilters={filters}
						setShowFilters={setShowFilters}
					/>
				)}
				{showColumnConfig && (
					<ConfigureColumnsNew
						show={showColumnConfig}
						onClose={() => setShowColumnConfig(false)}
						onSave={handleSaveColumns}
						docType="Supplier Group"
						defaultSelected={defaultSelectedColumns}
						fieldsData={columnsConfig.map((col) => ({
							fieldname: col.accessor,
							label: col.name,
						}))}
						disabledFields={["siNo", "name", "action"]}
					/>
				)}

				<Table
					columns={visibleColumns}
					data={tableData}
					loading={supplierGroupsLoading}
				/>
				<Pagination
					setCurrentPage={setCurrentPage}
					pageSize={pageSize}
					totalRecords={totalRecords}
					currentPage={currentPage}
					className="mt-2 pb-3"
        />
      
        {delPopupVisible && (
          
					<DelConfirmPopup
						alredysubmitdata={alreadySubmitData}
						delSelectedId={delSelectedId}
						visible={delPopupVisible}
						message={delmessage}
						onConfirm={delHandleConfirm}
						onCancel={delHandleCancel}
						delDone={delDone}
					/>
				)}
				{showExportPopup && (
					<ExportCSV
            doctype="Supplier Group"
            fieldsData={accessors}
						onClose={() => setShowExportPopup(false)}
					/>
				)}
				<PopBox
					isOpen={isPopBoxOpen}
					onClose={() => setIsPopBoxOpen(false)}
					title="Select Company"
				>
					<div className="selectbox">
						<p>Settings content goes here</p>
					</div>
				</PopBox>
			</ListLayout>
		</div>
	);
};

export default MainContent;
